import React from 'react';
import { serviceAreas } from '@data/serviceAreas';

const ResourcesSection: React.FC = () => {
  return (
    <section className="py-8 bg-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h3 className="text-lg font-semibold mb-4 text-gray-900">Resources</h3>
          <div className="flex flex-wrap gap-3 justify-center">
            {serviceAreas.map((area) => (
              <a
                key={area.id}
                href={area.href}
                className="bg-white hover:bg-gray-50 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg transition-colors"
              >
                {area.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;